<template>
    <div>
        <!-- v-on="$listeners" — 뷰어의 sendReportBlob 을 부모가 받을 수 있게 통과시킨다.
             마운트 직후 뷰어가 스스로 한 번 렌더하므로(ReportViewerSUPPLY.vue:123-131), 연속 생성 시
             그 렌더가 끝난 시점을 알아야 다음 렌더와 겹치지 않는다.
             기존 호출자 둘(ReportBulkGenerator.vue:259, ReplacementReport.vue:362)은 리스너를 걸지 않아 무해하다. -->
        <component :is="active_report_viewer"
                   v-if="active_report_viewer"
                   ref="resultReport"
                   :class="[view ? 'd-none' : null]"
                   :report_lang="report_lang"
                   :needReport="true"
                   :reportMode="reportMode"
                   :assessmentType="assessmentType"
                   :pdf_filename="pdf_filename"
                   :reportData="reportData"
                   :is_reassessment="is_reassessment"
                   :set_actual_duration="set_actual_duration"
                   v-on="$listeners"
        />
    </div>
</template>

<script>
import ReportViewerHMC from '@shared/components/admin/components/report/ReportViewerHMC.vue';
import ReportViewerKIA from '@shared/components/admin/components/report/ReportViewerKIA.vue';
import ReportViewerHMC_2025 from '@shared/components/admin/components/report/ReportViewerHMC_2025.vue';
import ReportViewerHYUNDAI from '@shared/components/admin/components/report/ReportViewerHYUNDAI.vue';
import ReportNamingMixin from '@shared/mixin/report/report.naming.mixin';
import {REPORT_RENDERERS} from '@shared/mixin/report/report-template';
import {mapActions, mapState} from 'vuex';
import ReportViewerKSTEEL from '@shared/components/admin/components/report/ReportViewerKSTEEL.vue';
import ReportViewerSUPPLY from '@shared/components/admin/components/report/ReportViewerSUPPLY.vue';
import ReportViewerHYUNDAI_V2 from '@shared/components/admin/components/report/ReportViewerHYUNDAI_V2.vue';
import ReportViewerHMC_THEME from '@shared/components/admin/components/report/ReportViewerHMC_THEME.vue';

export default {
    name: 'BulkReportContainer',
    mixins: [
        ReportNamingMixin
    ],
    components: {ReportViewerKSTEEL, ReportViewerSUPPLY, ReportViewerHYUNDAI_V2, ReportViewerHMC_THEME, ReportViewerHYUNDAI, ReportViewerHMC_2025, ReportViewerKIA, ReportViewerHMC},
    props: {
        view: {
            required: false,
            type: Boolean,
            default: false
        },
        report_lang: {
            type: String,
            default: 'ko'
        },
        reportMode: {
            type: String,
            default: 'view'
        },
        reportData: {
            required: false,
            type: Object,
            default: () => ({info: null, benchmarks: null, parser: null, risk: null, scoring: null})
        },
        pdf_filename: {
            required: false,
            type: String,
            default: ''
        },
        assessmentType: {
            required: false,
            type: String,
            default: 'DOC'
        },
        is_reassessment: {
            type: Boolean,
            default: false
        },
        set_actual_duration: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            // generatePDF 가 삼킨 마지막 예외. 반환값(undefined)은 기존 호출자 계약이라 그대로 두고 사유만 여기 남긴다.
            last_error: null,
        };
    },
    computed: {
        ...mapState('evaluations', ['audit_category']),
        // 판정(resolved_report_template, naming mixin)에 따른 뷰어 컴포넌트 등록명 — null 이면 미마운트.
        active_report_viewer () {
            const template = this.resolved_report_template;
            return template ? REPORT_RENDERERS[template].viewer : null;
        }
    },
    async created() {
     
    },
    mounted() {
    },
    methods: {
        ...mapActions('evaluations', ['fetchAuditCategory']),
        async generatePDF() {
            this.last_error = null;
            try {
                if (this.audit_category.length === 0) {
                    await this.fetchAuditCategory();
                }
                const result = await this.$refs.resultReport.generatePDF();
                this.$refs.resultReport.initializeReport();
                return result;
            }catch (e) {
                console.dir(e);
                this.last_error = e;
            }
            
        }
    }
};
</script>

<style lang="sass" scoped>

</style>
